export default function SumpPump() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 19L20 17L12 17L12 19L20 19Z" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7 16L7 8" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M25 16L25 8" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M23 17L23 7L9 7L9 17L23 17Z" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 10L22 10" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 13L22 13" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 27L10 21" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 27L14 21" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M18 27L18 21" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 27L22 21" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M27 27L27 21C27 19.8954 26.1046 19 25 19L7 19C5.89543 19 5 19.8954 5 21L5 27C5 28.1046 5.89543 29 7 29L25 29C26.1046 29 27 28.1046 27 27Z"
                stroke="black"
                stroke-width="1.3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M11.1316 6.09358C11.1359 5.59176 11.5438 5.18717 12.0457 5.18717H19.9695C20.4701 5.18717 20.8759 5.59298 20.8759 6.09358V6.43798C20.8759 6.74837 21.1276 7 21.438 7C21.7484 7 22 6.74837 22 6.43797V5.10695C22 4.48128 21.5291 4 20.9519 4H11.0481C10.4557 4 10 4.49733 10 5.10695V6.43562C10 6.74732 10.2527 7 10.5644 7C10.8742 7 11.1261 6.75019 11.1287 6.44035L11.1316 6.09358Z"
                fill="black"
            />
        </svg>
    );
}
